module.exports = __webpack_public_path__ + "static/media/external-causes-icon.b20fefbd.svg";